<template>
    <div class="tradShippAddress">
        <div class="tablePart">
            <!-- 新增收票地址 -->
            <div class="tableTool">
              <div class="toolRight">
                    <el-button type="primary" size="small" @click="toDialog('add','address')"><i
                       ></i>新增收票地址
                    </el-button>
                </div>
                <div class="toolLeft">
                    <span>已选： <span class="num">{{multipleSelection.length}}</span></span>
                    <el-button type="primary" plain size="small">批量删除</el-button>
                </div>
                
            </div>
            <el-table
                :data="tableData"
                border
                style="width: 100%" @selection-change="handleSelectionChange" class="tableContent">
                <el-table-column
                    type="selection"
                    header-align="center"
                    align="center"
                    width="55">
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="姓名"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="phone"
                    label="手机号"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                    >
                </el-table-column>
                <el-table-column
                    prop="addressDe"
                    label="收件地址"
                    header-align="center"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>
                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="toDialog('edit','address')">修改</el-button>
                        <el-button type="text" size="small">删除</el-button>
                        <el-button type="text" size="small">取消默认</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 新增收票邮箱 -->
            <div class="tableTool">
              <div class="toolRight">
                    <el-button type="primary" size="small" @click="toDialog2('add','email')"><i
                       ></i>新增收票邮箱
                    </el-button>
                </div>
                <div class="toolLeft">
                    <span>已选： <span class="num">{{multipleSelection2.length}}</span></span>
                    <el-button type="primary" plain size="small">批量删除</el-button>
                </div>
                
            </div>
            <el-table
                :data="tableData2"
                border
                style="width: 100%" @selection-change="handleSelectionChange2" class="tableContent">
                <el-table-column
                    type="selection"
                    header-align="center"
                    align="center"
                    width="55">
                </el-table-column>
                <el-table-column
                    prop="email"
                    label="邮箱"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                    width="340">
                </el-table-column>
                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="toDialog2('edit','email')">修改</el-button>
                        <el-button type="text" size="small">删除</el-button>
                        <el-button type="text" size="small">取消默认</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total,prev, pager, next,jumper"
                :page-size="10"
                :total="1000" class="pagination">
            </el-pagination>
        </div>
        <address-dialog ref="dialogRef"></address-dialog>
    </div>
</template>

<script>
    import addressDialog from './addressDialog'
    
    export default {
        data() {
            return {
                tableData: [
                    {
                        
                        name: '王丽',
                        phone:'15037847890',
                        addressDe:'横山大道中段春谷3D打印产业园',
                    }, 
                    {
                        
                        name: '王丽',
                        phone:'15037847890',
                        addressDe:'横山大道中段春谷3D打印产业园',
                    },
                    {
                        
                        name: '王丽',
                        phone:'15037847890',
                        addressDe:'横山大道中段春谷3D打印产业园',
                    },
                    {
                        
                        name: '王丽',
                        phone:'15037847890',
                        addressDe:'横山大道中段春谷3D打印产业园',
                    },
                ],
                tableData2: [
                    {
                        email:'ningxiahongyu@163.com'
                    }, 
                    {
                        email:'ningxiahongyu@163.com'
                    }, 
                    {
                        email:'ningxiahongyu@163.com'
                    }, 
                    {
                        email:'ningxiahongyu@163.com'
                    }, 
                ],
                multipleSelection: [],
                multipleSelection2: [],

            }
        },
        components: {
            addressDialog
        },
        methods: {
            // 复选框选中值
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            // 复选框选中值
            handleSelectionChange2(val) {
                this.multipleSelection2 = val
            },
            // 编辑/新增
            toDialog(type,news) {
                this.$refs.dialogRef.init(type,news)
            },
            // 编辑/新增
            toDialog2(type,news) {
                this.$refs.dialogRef.init(type,news)
            }
        }
    }
</script>

<style scoped lang="less">
    .tradShippAddress {
        padding: 20px;
        
        .searchPart {
            display: flex;
            flex-wrap: wrap;
            
            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }
            
            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;
                
                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;
                }
            }
            
            /deep/ .el-input__prefix {
                top: -3px;
            }
            
            /deep/ .el-input__suffix {
                top: 2px;
            }
            
            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }
            
            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #FFFFFF;
                margin-bottom:22px;
            }
            
            .resetBtn {
                color: #333333;
                margin-bottom:22px;
            }
        }
        
        .tablePart {
            .tableTool {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;
                
                .toolLeft {
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.847);
                    
                    .num {
                        color: #356FDF;
                    }
                    
                    button {
                        padding: 0;
                        margin-left: 15px;
                        width: 80px;
                        height: 30px;
                        background: rgba(242, 244, 247, 1);
                        box-sizing: border-box;
                        border: 1px solid rgba(21, 126, 251, 1);
                        border-radius: 5px;
                        font-size: 12px;
                        color: #157EFB;
                        line-height: 30px;
                        text-align: center;
                        
                        &:hover {
                            background: #157EFB;
                            box-sizing: border-box;
                            border: 1px solid #157EFB;
                            color: #fff;
                        }
                    }
                }
                
                .toolRight {
                    button {
                        // width: 83px;
                        height: 30px;
                        background: rgba(21, 126, 251, 1);
                        border: none;
                        border-radius: 15px;
                        font-size: 13px;
                        color: #fff;
                        
                        i {
                            padding-right: 5px;
                        }
                        
                        &:hover {
                            background: #61a2f0;
                        }
                    }
                }
            }
            
            .tableContent {
                // min-height: 650px;
                margin-bottom: 20px;
                
                /deep/ .el-table__header {
                    tr {
                        th {
                            border-right: none;
                        }
                    }
                    
                    /deep/ .el-table__cell {
                        padding: 5px 0;
                        background: #f2f5fc;
                    }
                }
                
                /deep/ .el-table__body {
                    img {
                        vertical-align: middle;
                        width: 52px;
                        height: 50px;
                    }
                    
                    /deep/ .el-table__row {
                        td:first-child {
                            border-right: none;
                            
                            .cell {
                                padding-left: 15px;
                            }
                        }
                    }
                }
            }
            
            .pagination {
                margin-top: 20px;
                text-align: right;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/service/addressManagement.vue